import React from 'react';
import ShareRedirect from './share-redirect';

const ShareResetPassword = () => <ShareRedirect shareType="resetPassword" />;

export default ShareResetPassword;
